import { render, staticRenderFns } from "./FirstTab.vue?vue&type=template&id=2c5e0fbb&scoped=true"
import script from "./FirstTab.vue?vue&type=script&lang=js"
export * from "./FirstTab.vue?vue&type=script&lang=js"
import style0 from "./FirstTab.vue?vue&type=style&index=0&id=2c5e0fbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5e0fbb",
  null
  
)

export default component.exports